import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppSettings } from '../appSettings';
import { CommonService } from '../services/common.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-chatlogin',
  templateUrl: './chatlogin.component.html',
  styleUrls: ['./chatlogin.component.css'],
})
export class ChatloginComponent implements OnInit, OnDestroy {
  model: any = {};
  step: string = 'lock';
  loading: boolean = false;
  returnUrl: string = '/chat';
  checkChatUserUrl: string = AppSettings.checkchatuser;
  setChatPwdUrl: string = AppSettings.setchatpwd;
  checkChatLoginUrl: string = AppSettings.checkchatlogin;

  constructor(
    private CommonService: CommonService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    document.body.className = 'login-page';
  }

  ngOnInit() {
    const requested = this.route.snapshot.queryParams['returnUrl'];
    this.returnUrl = this.safeReturnUrl(requested);
    if (localStorage.getItem('chatLogin') === '1' && localStorage.getItem('currentUserID')) {
      this.goToChat();
    }
  }

  ngOnDestroy() {
    this.restoreChatBody();
  }

  resetToLock() {
    this.step = 'lock';
    this.model.user_password = '';
    this.model.chatpwd = '';
    this.model.chatpwd_confirm = '';
    this.loading = false;
  }

  checkLock() {
    const username = this.model.user_name ? String(this.model.user_name).trim() : '';
    if (!username) {
      Swal.fire({ type: 'error', title: 'Oops...', text: 'Enter AI Internet Lock' });
      return;
    }
    this.loading = true;
    this.CommonService.checkexistdata(this.checkChatUserUrl, { user_name: username }).subscribe(data => {
      this.loading = false;
      if (data.exist == 1) {
        this.model.user_name = username;
        this.model.user_password = '';
        this.model.chatpwd = '';
        this.model.chatpwd_confirm = '';
        this.step = (data.chatpwd_set == 1) ? 'chatpwd' : 'setpwd';
      } else {
        Swal.fire({ type: 'error', title: 'Oops...', text: data.message || 'Enter valid AI Internet Lock' });
      }
    }, () => {
      this.loading = false;
      Swal.fire({ type: 'error', title: 'Oops...', text: 'Unable to check AI Internet Lock' });
    });
  }

  setChatPassword() {
    const username = this.model.user_name ? String(this.model.user_name).trim() : '';
    const password = this.model.user_password ? String(this.model.user_password).trim() : '';
    const chatpwd = this.model.chatpwd ? String(this.model.chatpwd).trim() : '';
    const confirmPwd = this.model.chatpwd_confirm ? String(this.model.chatpwd_confirm).trim() : '';
    if (!username || !password || !chatpwd) {
      Swal.fire({ type: 'error', title: 'Oops...', text: 'Enter AI Internet Lock, Key and Chat password' });
      return;
    }
    if (chatpwd !== confirmPwd) {
      Swal.fire({ type: 'error', title: 'Oops...', text: 'Chat password and confirm password do not match' });
      return;
    }
    this.loading = true;
    this.CommonService.checkexistdata(this.setChatPwdUrl, {
      user_name: username,
      user_password: password,
      chatpwd: chatpwd
    }).subscribe(data => {
      this.loading = false;
      if (data.exist == 1) {
        Swal.fire({ type: 'success', title: '', text: data.message || 'Chat password set successfully' });
        this.model.user_password = '';
        this.model.chatpwd = '';
        this.model.chatpwd_confirm = '';
        this.step = 'lock';
      } else {
        Swal.fire({ type: 'error', title: 'Oops...', text: data.message || 'Unable to set Chat password' });
      }
    }, () => {
      this.loading = false;
      Swal.fire({ type: 'error', title: 'Oops...', text: 'Unable to set Chat password' });
    });
  }

  checkChatLogin() {
    const username = this.model.user_name ? String(this.model.user_name).trim() : '';
    const chatpwd = this.model.chatpwd ? String(this.model.chatpwd).trim() : '';
    if (!username || !chatpwd) {
      Swal.fire({ type: 'error', title: 'Oops...', text: 'Enter AI Internet Lock and Chat password' });
      return;
    }
    this.loading = true;
    this.CommonService.checkexistdata(this.checkChatLoginUrl, {
      user_name: username,
      chatpwd: chatpwd
    }).subscribe(data => {
      this.loading = false;
      if (data.exist == 1 && data.result && data.result[0]) {
        this.saveChatSession(data.result[0]);
        this.goToChat();
      } else {
        Swal.fire({ type: 'error', title: 'Oops...', text: data.message || 'Enter valid user credentials' });
      }
    }, () => {
      this.loading = false;
      Swal.fire({ type: 'error', title: 'Oops...', text: 'Unable to open Chat' });
    });
  }

  private saveChatSession(user_det: any) {
    localStorage.setItem('chatLogin', '1');
    localStorage.setItem('currentUser', user_det.username);
    localStorage.setItem('currentUserID', user_det.id);
    localStorage.setItem('currentUsergroup', user_det.user_type);
    localStorage.setItem('usergroup', user_det.user_type);
    localStorage.setItem('user_fname', user_det.fname);
    localStorage.setItem('email', user_det.email);
    localStorage.setItem('address', user_det.address);
    localStorage.setItem('tamount', user_det.tamount);
    localStorage.setItem('pcktaken', user_det.pcktaken);
    if (user_det.packInfo && user_det.packInfo.website_type) {
      localStorage.setItem('userRole', user_det.packInfo.website_type);
    }
    localStorage.setItem('mebankshow', user_det.mebankshow);
    localStorage.setItem('mebankstatus', user_det.mebankstatus);
  }

  private goToChat() {
    this.restoreChatBody();
    this.router.navigate([this.returnUrl]);
  }

  private restoreChatBody() {
    document.body.className = 'theme-red';
  }

  private safeReturnUrl(url: string) {
    if (url === '/mychat' || url === '/chat') {
      return url;
    }
    return '/chat';
  }
}
